export default [
  { id: 0, label: "normal" },
  { id: 1, label: "offer" },
];
